import AJV from 'ajv/dist/2020';

/**  Export AJV module  */
export * from 'ajv/dist/2020';
export default AJV;
